import React from 'react';
import { ContainerShimmerEffect, ShimmerEffect } from './styles';

// import { Container } from './styles';

const LoadingState: React.FC = () => {
  return (
    <ContainerShimmerEffect>
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
    </ContainerShimmerEffect>
  );
};

export default LoadingState;
